import React, { useMemo } from 'react';
import { FormGroup, ControlLabel, Collapse, Badge } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Translations from '../../../../../../../components/Collapse/Translations';
import Summernote from '../../../../../../../components/Summernote';

import { summernoteOptions } from '../../../../helpers';
import { stripTagsWith } from '../../../../../../../utils/helper';

const stripTagsArray = ['link'];

const FieldsInstructions = ({ isOpenInstructions, item, languages, defaultLanguage, onChange, setOpenInstructions }) => {
  const defaultInstruction = useMemo(() => {
    const finded = languages?.find((language) => language.code === defaultLanguage);
    const value = item?.details?.instructions?.[finded?.code];
    return {
      ...finded,
      value: stripTagsWith(value, stripTagsArray),
    };
  }, [defaultLanguage, item.details.instructions, languages]);
  const anotherInstructions = useMemo(
    () => languages
      ?.filter((language) => language.code !== defaultLanguage)
      ?.map((language) => {
        const value = item?.details?.instructions?.[language.code];
        return {
          ...language,
          value: stripTagsWith(value, stripTagsArray),
        }
      }),
    [defaultLanguage, item.details.instructions, languages],
  );
  return (
    <>
      <FormGroup
        className={classNames({
          'form-group__rtl': defaultInstruction?.direction === 'rtl',
        })}
      >
        <ControlLabel htmlFor={`${defaultInstruction?.code}`}>
          Instruction
          {' '}
          <Badge>{defaultInstruction?.name}</Badge>
        </ControlLabel>
        <Translations onOpen={() => setOpenInstructions(!isOpenInstructions)} open={isOpenInstructions} items={languages}>
          <Summernote value={defaultInstruction.value || ''} name={`instructions[${defaultInstruction?.code}]`} options={summernoteOptions} />
        </Translations>
      </FormGroup>
      <Collapse in={isOpenInstructions} mountOnEnter>
        <div>
          {anotherInstructions?.length
            ? anotherInstructions?.map((language) => (
              <FormGroup key={`${language?.code}`}>
                <ControlLabel htmlFor={`${language?.code}`}>
                  Instruction
                  {' '}
                  <Badge>{language?.name}</Badge>
                </ControlLabel>
                <Summernote
                  value={language.value || ''}
                  options={summernoteOptions}
                  name={`instructions[${language?.code}]`}
                  onChange={(value) => onChange(language.code, value)}
                />
              </FormGroup>
            ))
            : null}
        </div>
      </Collapse>
    </>
  );
};

FieldsInstructions.propTypes = {
  isOpenInstructions: PropTypes.bool,
  item: PropTypes.object,
  defaultLanguage: PropTypes.string,
  languages: PropTypes.array,
  setOpenInstructions: PropTypes.func,
  onChange: PropTypes.func,
};

export default FieldsInstructions;
